<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>对公充值</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">对公充值</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <!-- <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入账号名称"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="充值人名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name1"
                    placeholder="请输入充值人名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="充值人手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入充值人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto;"
                  >
                    <el-option label="未确认" value="0"></el-option>
                    <el-option label="已确认" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="display: flex;align-items: center;">
          <el-upload
            class="upload-demo"
            :on-progress="selectFile"
            :action="uploadUrl"
            :headers="deader"
            :on-success="handSuccess"
            :limit="1"
            :multiple="false"
            :show-file-list="false"
          >
            <el-button type="primary" class="btn" v-loading="loading"
              >导入银行收入明细excel</el-button
            >
          </el-upload>
          <el-button style="margin-left: 20px;" @click="dowon"
            >下载模板</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.scrollTable" />
        <el-table
          ref="scrollTable"
          :data="tableData"
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="充值人" align="center" width="150">
            <template slot-scope="scope">{{ scope.row.accountName }}</template>
          </el-table-column>
          <el-table-column label="充值金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.debitAmount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column label="充值类型" align="center">
            <template slot-scope="scope">对公</template>
          </el-table-column>

          <el-table-column label="手机号" align="center" width="150">
            <template slot-scope="scope">{{ scope.row.memberPhone }}</template>
          </el-table-column>

          <el-table-column label="开户行" align="center" width="180">
            <template slot-scope="scope">{{ scope.row.payerBank }}</template>
          </el-table-column>
          <el-table-column label="开户行银行号" align="center" width="180">
            <template slot-scope="scope">{{ scope.row.payerNo }}</template>
          </el-table-column>
          <el-table-column label="充值账号" align="center" width="180">
            <template slot-scope="scope">{{ scope.row.accountNo }}</template>
          </el-table-column>
          <el-table-column label="备注" align="center" width="130">
            <template slot-scope="scope"> {{ scope.row.memo }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="130">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">未确认</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已确认</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="payAt"
            label="交易时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作人名" align="center">
            <template slot-scope="scope">{{ scope.row.creatorName }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="150"
          >
            <template slot-scope="scope">
              <div>
                <div class="disAround" v-if="scope.row.status == 0">
                  <div class="operateBtn" @click="handleEdit(scope.row)">
                    确认充值
                  </div>
                </div>
                <div class="operateBtn" @click="deleteData(scope.row.id)">
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="确认充值"
      :visible.sync="dialogFormVisible"
      width="800px"
      :before-close="handleClose2"
    >
      <el-form ref="ruleForm" :model="ruleForm2">
        <el-row :gutter="6">
          <el-col :span="8">
            <el-form-item>
              <el-input
                v-model="ruleForm2.name"
                placeholder="请输入名称"
                @focus="clearData"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-input
                v-model="ruleForm2.phone"
                placeholder="请输入手机号"
                @focus="clearData"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button type="primary" @click="selectList()" class="btn"
                >查询</el-button
              >
              <el-button @click="resetForm1()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="singleTable"
        :data="options"
        style="width: 100%"
        highlight-current-row
        @current-change="selectItem"
        max-height="300"
      >
        <el-table-column align="center" width="20">
          <template slot-scope="scope">
            <div
              :class="[scope.row.id == selectUserId ? 'select' : 'noSelect']"
            ></div>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="id"> </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.accountType == 0 ? "企业" : "个人" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center">
          <template slot-scope="scope">
            <span
              >{{ scope.row.cardName }}({{
                scope.row.phone | maskPhoneNumber
              }})</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="pageSize1"
        layout="total, prev, pager, next,sizes"
        :total="total1"
      >
      </el-pagination>
      <el-button type="primary" @click="submitForm()" style="width: 100%"
        >确定</el-button
      >
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div style="margin-top: 10px;">总条数：{{ exceprt.totalCount }}</div>
      <div style="margin-top: 10px;">成功条数：{{ exceprt.successCount }}</div>
      <div style="margin-top: 10px;">失败条数：{{ exceprt.errorCount }}</div>
      <div style="margin-top: 10px;">失败信息：</div>
      <div
        v-for="(item, index) in exceprt.errorMessages"
        :key="index"
        style="padding-left: 30px;margin-top: 5px;"
      >
        {{ item }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="excopt()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      style="z-index: 9999;"
      title="提示"
      :visible.sync="dialogVisible1"
      width="30%"
      :append-to-body="true"
    >
      <div style="font-size: 22px;margin-bottom: 10px;">是否确认充值</div>
      <div style="display: flex;align-items: center;">
        <div style="flex: none;">备注：</div>
        <el-input v-model="remark" placeholder="请输入备注"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1()">取消</el-button>
        <el-button type="primary" @click="tijiao()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      dialogVisible: false,
      ruleForm: {
        name: "",
        name1: "",
        time: "",
        time1: "",
        phone: "",
        status: ""
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      page1: 1,
      pageSize1: 5,
      total1: 0,
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN")
      },
      dialogFormVisible: false,
      value: "",
      options: [],
      ruleForm2: {
        name: "",
        phone: ""
      },
      selectUserId: "",
      confrimId: "",
      uploadUrl: "",
      loading: false,
      remark: "",
      dialogVisible1: false,
      exceprt: "" //导入后的提示信息
    };
  },
  mounted() {
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/recharge/import";
    this.getList();
  },
  methods: {
    handleClose1() {
      this.dialogVisible1 = false;
      // this.dialogVisible = false;
    },
    selectFile() {
      this.loading = true;
    },
    selectList() {
      if (this.selectData.memberId && this.selectData.memberId != 0) {
        this.bodyguard();
      } else {
        this.bodyguard1();
      }
    },
    dowon() {
      window.open(
        "http://down.baoanlailou.com/file/excel/excel-%E5%85%85%E5%80%BC%E6%A8%A1%E7%89%88.xlsx"
      );
    },
    clearData() {
      this.selectUserId = "";
      this.$refs.singleTable.clearSelection();
    },
    selectItem(val) {
      console.log(val);
      this.selectUserId = val == null ? "" : val.id;
    },
    submitForm() {
      if (this.selectUserId == "") {
        this.$message({
          message: "请选择充值账号",
          type: "warning"
        });
      } else {
        this.dialogVisible1 = true;
        console.log(this.dialogVisible1);
        this.dialogFormVisible = false;
      }
    },
    tijiao() {
      let param = {
        customId: this.selectUserId,
        id: this.confrimId,
        memo: this.remark
      };
      this.$axios
        .post(`/admapi/recharge/confirm`, param)
        .then(({ data }) => {
          this.$message({
            message: "确认成功",
            type: "success"
          });
          this.dialogVisible1 = false;
          this.getList();
        })
        .catch()
        .finally();
    },
    handleEdit(val) {
      let str = val.memo;
      if (str != "") {
        // 1. 截取前 11 位
        const phonePrefix = str ? str.substring(0, 11) : "";
        // 2. 判断是否为 11 位数字，且符合手机号规则
        const phoneRegex = /^1[3-9]\d{9}$/;
        // 3. 验证
        const isPhone = phoneRegex.test(phonePrefix);
        if (isPhone == true) {
          this.ruleForm2.phone = phonePrefix;
        }
      }
      this.selectData = val;
      this.dialogFormVisible = true;
      this.confrimId = val.id;
      this.value = "";
      if (val.memberId && val.memberId != 0) {
        this.bodyguard();
      } else {
        this.bodyguard1();
      }
    },
    handleClose2() {
      this.dialogFormVisible = false;
      this.ruleForm2.phone = "";
    },
    handleClose() {
      this.dialogVisible = false;
      location.reload();
    },
    excopt() {
      this.dialogVisible = false;
      this.ruleForm2.phone = "";
      location.reload();
    },
    handSuccess(res) {
      this.exceprt = res.data;
      this.loading = false;
      if (res.data.errorCount == 0) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        location.reload();
      } else {
        this.dialogVisible = true;
      }
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.name1 = "";
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.ruleForm.phone = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.selectList();
    },
    handleCurrentChange1(val) {
      this.page1 = val;
      this.selectList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize
      };
      if (this.ruleForm.name1 != "") {
        param.memberName = this.ruleForm.name1;
      }
      if (this.ruleForm.time != "") {
        param.startTime = this.ruleForm.time;
        param.endTime = this.ruleForm.time1;
      }
      if (this.ruleForm.phone != "") {
        param.phone = this.ruleForm.phone;
      }
      if (this.ruleForm.status != "") {
        param.status = this.ruleForm.status;
      }
      this.$axios
        .post(`/admapi/recharge/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    resetForm1() {
      this.ruleForm2.name = "";
      this.bodyguard();
    },
    deleteData(val) {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(`/admapi/recharge/del/${val}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    bodyguard() {
      let param = {
        page: this.page1,
        pageSize: this.pageSize1,
        queryParams: []
      };
      if (this.ruleForm2.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm2.name
        });
      }
      if (this.ruleForm2.phone != "") {
        param.queryParams.push({
          name: "phone",
          type: "select",
          values: [{ itemKey: this.ruleForm2.phone }]
        });
      }
      this.$axios
        .post(`/admapi/bodyguard/list`, param)
        .then(({ data }) => {
          this.options = data.items;
        })
        .catch()
        .finally();
    },
    bodyguard1() {
      let param = {
        page: this.page1,
        pageSize: this.pageSize1,
        queryParams: []
      };
      if (this.ruleForm2.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm2.name
        });
      }
      if (this.ruleForm2.phone != "") {
        param.queryParams.push({
          name: "phone",
          type: "select",
          values: [{ itemKey: this.ruleForm2.phone }]
        });
      }
      this.$axios
        .post(`/admapi/custom/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          for (var i = 0; i < arr.length; i++) {
            arr[i].cardName = arr[i].name;
          }
          this.options = arr;
          this.total1 = data.page.totalRows;
        })
        .catch()
        .finally();
    }
  }
};
</script>
<style scoped>
.noSelect {
  width: 10px;
  height: 10px;
  border: #165dff 1px solid;
  border-radius: 10px;
}
.select {
  width: 10px;
  height: 10px;
  background: #165dff;
  border-radius: 10px;
}
</style>
